module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ANh"
    }
  }, [_c('div', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "images/himg-6-1.jpg",
      "src": "images/himg-6-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    attrs: {
      "id": "pz21-3"
    }
  }, [_c('b', [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("T")])]), _vm._v("hroughout the Sermon on the Mount, Jesus offered straightforward and radical instructions for His followers—among them: “agree with your adversary quickly”; don’t “resist an evil person. . . . whoever slaps you on your right cheek, turn the other to him also”; and “whoever compels you to go one mile, go with him two” (Matthew 5:25, 39, 41). Such instructions would have puzzled His listeners. ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz21-4"
    }
  }, [_vm._v("Jesus summarized these sayings with the commands, “Love your enemies, bless those who curse you, [and] do good to those who hate you” (v. 44). In Jesus’ day, the Romans were the Jews’ enemies and oppressors. The Romans could force Jews, randomly chosen along the road, to carry whatever needed to be carried. Yet Jesus told His listeners to love these enemies by carrying the load not just for one mile but for two miles. ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz21-5"
    }
  }, [_vm._v("Be aware of times when you could stop—figuratively speaking—at one mile when asked to help someone. Take a minute to consider going a second mile, knowing the difference a little extra work will make, especially if you help someone with whom you don’t get along. ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6d884a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter16.vue
// module id = 111
// module chunks = 0